import type { Instrument } from '@/core/instruments/shapes';
import styles from './InstrumentSelect.module.css';

const OPTIONS: { value: Instrument; label: string }[] = [
  { value: 'guitar', label: 'Guitar' },
  { value: 'ukulele', label: 'Ukulele' },
  { value: 'mandolin', label: 'Mandolin' },
  { value: 'bass', label: 'Bass' },
  { value: 'piano', label: 'Piano' },
];

interface InstrumentSelectProps {
  /** Accessible name (the dropdown has no visible label). */
  label: string;
  value: Instrument;
  onChange: (instrument: Instrument) => void;
  /** Fill the container's width. */
  stretch?: boolean;
}

/** Instrument dropdown for the chord diagrams, styled like the pill controls beside it. */
export function InstrumentSelect({ label, value, onChange, stretch }: InstrumentSelectProps) {
  return (
    <span className={styles.wrap} data-stretch={stretch ? true : undefined}>
      <select
        aria-label={label}
        className={styles.select}
        value={value}
        onChange={(e) => {
          onChange(e.target.value as Instrument);
        }}
      >
        {OPTIONS.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
      <svg className={styles.chevron} viewBox="0 0 10 6" aria-hidden="true">
        <path
          d="M1 1l4 4 4-4"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
